import { useMutation } from '@apollo/client'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Button } from '..'
import { createOrderQuery } from '../../queries'
import { CreateOrder, CreateOrderVariables } from '../../queries/types/CreateOrder'
import { FindProducts_findProducts } from '../../queries/types/FindProducts'
import { App } from '../../types/global'
import { Currency, PaymentMethod } from '../../types/graphql-global-types'
import { ApolloStateButton } from '../button'
import { MonoId } from '../ui'

interface ProductRowAttributes {
    app: App | null
    product: FindProducts_findProducts
}

export function ProductRow(props: ProductRowAttributes): JSX.Element {
    const {t} = useTranslation()
    const history = useHistory()
    const [ createOrder, createOrderResult ] = useMutation<CreateOrder, CreateOrderVariables>(createOrderQuery)
    const product = props.product
    const app = props.app

    function createOrderAndGo(product: FindProducts_findProducts, method: PaymentMethod) {
        if (app == null) return
        createOrder({
            variables: {
                appID: app.id,
                productID: product.id,
                method: method,
                currency: Currency.MMK
            }
        }).then(res => {
            if (res.data) {
                const orderId = res.data.createOrder.id
                toast.info(`Order created: ${orderId}`)
                if (process.env.REACT_APP_FRONTEND_VIEW_ORDER_URL) {
                    const baseUrl = process.env.REACT_APP_FRONTEND_VIEW_ORDER_URL.replace(/\/$/, '')
                    window.open(`${baseUrl}/${orderId}`, '_blank')
                }
            }
        }).catch(() => {/**/})
    }

    return (
        <tr className='border-b border-gray-100 last:border-0 hover:bg-gray-50'>
            <td className='px-4 py-3'><MonoId value={product.id} /></td>
            <td className='px-4 py-3 text-gray-800'>{product.title}</td>
            <td className='px-4 py-3 text-gray-800 whitespace-nowrap'>{product.priceList.MMK?.toCurrency() ?? '—'}</td>
            <td className='px-4 py-3 text-gray-800 whitespace-nowrap'>{product.priceList.USD?.toCurrency('USD') ?? '—'}</td>
            <td className='px-4 py-3'>
                <div className='flex flex-row items-center gap-2'>
                    <ApolloStateButton size='sm' result={createOrderResult} onClick={() => createOrderAndGo(product, PaymentMethod.kbzPayQR)}>{t('shared.method.kbzPayQR')}</ApolloStateButton>
                    <ApolloStateButton size='sm' result={createOrderResult} onClick={() => createOrderAndGo(product, PaymentMethod.kbzPayWeb)}>{t('shared.method.kbzPayWeb')}</ApolloStateButton>
                </div>
            </td>
            <td className='px-4 py-3'>
                <div className='flex justify-end'>
                    <Button size='sm' onClick={() => history.push(`/products/edit/${product.id}`)}>{t('products.table.actions.edit')}</Button>
                </div>
            </td>
        </tr>
    )
}
